module.exports = __webpack_public_path__ + "img/logo-branding-small.5139955f.svg";